<!--
 * @Author: cgh
 * @Date: 2022-08-10 11:07:41
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 14:53:19
 * @Description: 建筑信息修改/添加
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-60 o-dialog--lg-60 o-dialog--xl-60"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row
          class="c-form__row"
        >
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="建筑名称"
              prop="jzwmc"
            >
              <el-input
                v-model="fd.jzwmc"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入建筑名称"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="建筑地址"
              prop="jzwdz"
            >
              <el-input
                v-model="fd.jzwdz"
                class="c-form__input"
                autocomplete="off"
                placeholder="请输入建筑地址"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="建筑类别"
              prop="jzlbDm"
            >
              <el-select
                v-model="fd.jzlbDm"
                class="c-form__select"
                placeholder="请选择建筑类别"
                clearable
              >
                <el-option
                  v-for="item in jzlbType"
                  :key="item.id"
                  :label="item.text"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="自动消防设施"
              prop="zdxfss"
            >
              <el-radio-group
                v-model="fd.zdxfss"
                class="c-form__radio-group"
              >
                <el-radio label="Y">
                  有
                </el-radio>
                <el-radio label="N">
                  无
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="占地面积（m²）"
              prop="zdmj"
            >
              <el-input
                v-model="fd.zdmj"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入占地面积！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="建筑面积（m²）"
              prop="jzmj"
            >
              <el-input
                v-model="fd.jzmj"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入建筑面积！"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="楼层数"
              prop="lcs"
            >
              <el-input
                v-model="fd.lcs"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入楼层数"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="建筑高度（m）"
              prop="jzgd"
            >
              <el-input
                v-model="fd.jzgd"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入建筑高度（m）"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="地上层层数"
              prop="dscs"
            >
              <el-input
                v-model="fd.dscs"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入地上层层数"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="地下层数"
              prop="dxcs"
            >
              <el-input
                v-model="fd.dxcs"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入地下层数"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="安全出口数（个）"
              prop="aqcks"
            >
              <el-input
                v-model="fd.aqcks"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入安全出口数（个）"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="疏散楼梯数（个）"
              prop="sslts"
            >
              <el-input
                v-model="fd.sslts"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="疏散楼梯数（个）"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="消防电梯数（个）"
              prop="xfdts"
            >
              <el-input
                v-model="fd.xfdts"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入消防电梯数（个）"
              />
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="12"
          >
            <el-form-item
              class="c-form__item"
              label="避难层位置"
              prop="bncwz"
            >
              <el-input
                v-model="fd.bncwz"
                class="c-form__input"
                autocomplete="off"
                maxlength="60"
                placeholder="请输入避难层位置"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { jzxxService } from './jzxx.service.js';
export default {
  name: 'UpdateJzxxDialog',
  props: {
    dlParams: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示

      loading: false, // 页面是否加载
      xmid: null, // 项目id
      id: null, // 建筑id
      /* 表单参数 Start */
      fd: {
        jzwmc: null,
        jzwdz: null,
        jzlbDm: null, // 建筑类别
        zdxfss: null, // 自动消防设施
        zdmj: null, // 占地面积
        jzmj: null, // 建筑面积
        lcs: null, // 楼层数
        jzgd: null, // 建筑高度
        dscs: null, // 地上层层数
        dxcs: null, // 地下层层数
        aqcks: null, // 安全出口数
        sslts: null, // 疏散楼梯数
        xfdts: null, // 消防电梯数
        bncwz: null // 避难层位置
      },
      /* 表单参数 End */
      /* 表单校验规则 Start */
      fdRules: {
        jzwmc: [
          this.$validUtils.required('建筑名称'),
          this.$HMValidator.maxLength('建筑名称', 300)
        ],
        jzwdz: [
          this.$validUtils.required('建筑地址'),
          this.$HMValidator.maxLength('建筑地址', 300)
        ],
        jzlbDm: [
          this.$validUtils.required('建筑类别')],
        zdxfss: [
          this.$validUtils.required('自动消防设施')],
        zdmj: [
          this.$validUtils.required('占地面积'),
          this.$HMValidator.money('占地面积', 8, 2)],
        jzmj: [
          this.$validUtils.required('建筑面积'),
          this.$HMValidator.money('建筑面积', 8, 2)],
        jzgd: [
          this.$validUtils.required('建筑高度'),
          this.$HMValidator.money('建筑高度', 8, 2)],
        lcs: [
          this.$validUtils.required('楼层数'),
          this.$HMValidator.number('楼层数'),
          this.$validUtils.maxNumberValid('楼层数')
        ],
        dxcs: [
          this.$validUtils.required('地下层数'),
          this.$HMValidator.number('地下层数'),
          this.$validUtils.maxNumberValid('地下层数')
        ],
        dscs: [
          this.$validUtils.required('地上层层数'),
          this.$HMValidator.number('地上层层数'),
          this.$validUtils.maxNumberValid('地上层层数')
        ],
        aqcks: [
          this.$HMValidator.number('安全出口数'),
          this.$validUtils.maxNumberValid('安全出口数')
        ],
        sslts: [
          this.$HMValidator.number('疏散楼梯数'),
          this.$validUtils.maxNumberValid('疏散楼梯数')

        ],
        xfdts: [
          this.$HMValidator.number('消防电梯数'),
          this.$validUtils.maxNumberValid('消防电梯数')

        ],
        bncwz: [
          this.$HMValidator.maxLength('避难层位置', 300)
        ]
      },
      dlType: 'add' // 模态框类型，'add': 新增，'edit': 修改
      /* 表单校验规则 End */
    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'edit' ? '修改信息' : '添加信息'}`;
    },
    /* 建筑类别 */
    jzlbType () {
      const enums = this.$store.state.apiEnums.iffApi;
      if (enums && enums.IFF_JZLB_PG) {
        return enums.IFF_JZLB_PG;
      }
      return {};
    }

  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },
    /**
     * 初始化数据
     */
    init () {
      // this.loading = true;
      jzxxService.getjzxxInfo(this.xmid, this.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取评估仪器信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        // this.loading = true;
        if (valid) {
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      jzxxService.addJzxx(this.xmid, this.fd)
        .then(rsp => {
          this.$message({
            message: '新增成功！',
            type: 'success'
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      jzxxService.updateJzxx(this.xmid, this.id, this.fd)
        .then(rsp => {
          this.$message({
            message: '修改成功！',
            type: 'success'
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    }

  },
  created () {
    this.xmid = this.dlParams.xmid;
    console.log(this.dlParams);
    console.log(this.dlParams.id);
    if (this.dlParams.id) {
      this.dlType = this.dlParams.type;
      this.id = this.dlParams.id;
      this.init();
    }
  }
};

</script>
